module.exports = __webpack_public_path__ + "img/defaultAddress.30f710eb.png";